// extracted by mini-css-extract-plugin
export default {"text":"WhitOutPost_text__zBTy-"};